import { render, staticRenderFns } from "./edit-news.vue?vue&type=template&id=0d3f3af7&scoped=true&"
import script from "./edit-news.vue?vue&type=script&lang=js&"
export * from "./edit-news.vue?vue&type=script&lang=js&"
import style0 from "./edit-news.vue?vue&type=style&index=0&id=0d3f3af7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3f3af7",
  null
  
)

export default component.exports